/*
 * $Id:: service.js 2021/01/15 04:20 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { sendRequest } from '../../common/utils';

export const authenticateUser = (params) => {
    return sendRequest({
        url: '/auth/login',
        method: 'POST',
        body: params,
        doNotRedirect: true,
    })
        .then((response) => {
            const { redirect } = response;
            if (redirect) {
                return response;
            }
            return;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const requestHydraLogoutChallenge = () => {
    return sendRequest({
        url: '/sessions/logout',
        prefix: '/oauth2',
        method: 'GET',
    })
        .then((res) => {
            return { username: res.sub, sid: res.sid };
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const requestLogoutHydraRequest = (challenge) => {
    return sendRequest({
        url: '/auth/logout',
        method: 'POST',
        body: { challenge },
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const logoutAuthenticatedUser = () => {
    return new Promise();
};
